module.exports = __webpack_public_path__ + "static/media/striped_bar_postinspect_tall.96f7f4f3.svg";